/** @format — Open a fresh chat so a shipment can be started with Dockie */

export const START_SHIPMENT_FLAG = "dockie:start-shipment";

export function goToNewShipmentChat(navigate) {
  try {
    sessionStorage.setItem(START_SHIPMENT_FLAG, "1");
  } catch {
    // sessionStorage can be unavailable; chat still opens without auto-creating.
  }
  navigate("/chats/new");
}

/** Returns true once per click, including under React strict-mode remounts. */
export function consumeStartShipmentIntent() {
  try {
    if (sessionStorage.getItem(START_SHIPMENT_FLAG) !== "1") return false;
    sessionStorage.removeItem(START_SHIPMENT_FLAG);
    return true;
  } catch {
    return false;
  }
}
